import {client} from "@/httpClient";
import {useMutation, type UseMutationOptions} from "@tanstack/react-query";

export const CAMPAIGN_APPLICATION_KEYS = {
  mApplication: (applicationId: number) => [`/campaign_application/${applicationId}/`],
  mApplicationAccept: (applicationId: number) => [`/campaign_application/${applicationId}/accept/`],
  mApplicationCancel: (applicationId: number) => [`/campaign_application/${applicationId}/cancel/`],
  mApplicationDecline: (applicationId: number) => [`/campaign_application/${applicationId}/decline/`],
  mApplicationExtendCompleted: (applicationId: number) => [`/campaign_application/${applicationId}/extend_completed/`],
  mApplicationFeaturedInstagramMedia: ["/campaign_application/feature_instagram_media/"],
  mApplicationFeaturedTikTokMedia: ["/campaign_application/feature_tiktok_media/"],
  mApplicationFeaturedUgcMedia: (contentId: number) => [`/ugc_media/${contentId}/feature/`],
  mApplicationLikedMedia: ["/campaign_application/like_media/"],
  mApplicationPending: (applicationId: number) => [`/campaign_application/${applicationId}/pending/`],
  mApplicationRenegotiation: (applicationId: number) => [`/campaign_application/${applicationId}/renegotiate_price/`],
  mApplicationSpeedyReward: (applicationId: number) => [`/campaign_application/${applicationId}/payout_speedy_reward/`],
} as const;

export const usePayoutSpeedyRewardMutation = ({
  applicationId,
  mutationOptions,
}: {
  applicationId: number;
  mutationOptions?: Partial<UseMutationOptions>;
}) =>
  useMutation({
    mutationKey: CAMPAIGN_APPLICATION_KEYS.mApplicationSpeedyReward(applicationId),
    mutationFn: () => client.post(CAMPAIGN_APPLICATION_KEYS.mApplicationSpeedyReward(applicationId)[0]),
    ...mutationOptions,
  });
